import { Container } from "@pixi/display";
import { Spine } from "pixi-spine";
import { PreloaderResourcesPackage } from "../resources/PreloaderResourcesPackage";

export class ProgressBarSpine extends Container {
    private animation: Spine;
    private currentStep = -1;
    private readonly TOTAL_STEPS = 20;

    private readonly PROGRESS_ANIMATIONS: Record<number, string> = {
        0: "progres_0",
        1: "progres_1",
        2: "progres_2",
        3: "progres_3",
        4: "progres_4",
        5: "progres_5",
        6: "progres_6",
        7: "progres_7",
        8: "progres_8",
        9: "progres_9",
        10: "progres_10",
        11: "progres_11",
        12: "progres_12",
        13: "progres_13",
        14: "progres_14",
        15: "progres_15",
        16: "progres_16",
        17: "progres_17",
        18: "progres_18",
        19: "progres_19",
        20: "progres_20"
    };

    public set value(value: number) {
        this.progressValue = Math.max(Math.min(value, 1), 0);
        this.onProgress();
    }

    public get value(): number {
        return this.progressValue;
    }
    
    constructor(resources: PreloaderResourcesPackage, private progressValue: number = 0) {
        super();
        this.animation = new Spine((resources.assets_preloader_progress_progres_json as any).spineData);
        this.animation.state.setAnimation(0, "progres_0", false);
        this.addChild(this.animation);
    }

    protected onProgress(): void {
        const targetStep = Math.min(
            Math.floor(this.progressValue * this.TOTAL_STEPS),
            this.TOTAL_STEPS
        );

        if (targetStep === this.currentStep) {
            return;
        }

        const animationName = this.PROGRESS_ANIMATIONS[targetStep];

        if (animationName) {
            this.animation.state.setAnimation(0, animationName, false);
            this.currentStep = targetStep;
        } else {
            console.warn(`Spine animation not found for step: ${targetStep}`);
        }
    }
}